import TeachersScreen from './containers/teachersScreen'

export {default as TeachersScreenLayout} from './components/teachersScreenLayout'

export default TeachersScreen
